import { MetabaseCard } from "@shared/components/metabase";

export class AgentReportModel extends MetabaseCard {
}
